import React from 'react';
import Select from 'react-select';
import styles from './CustomOutletDropdown.css';

class CustomOutletDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectInstance: 1,
    };
  }

  onChangeSelect = newval => {
    const {
      input: { onChange },
    } = this.props;
    onChange(newval.value);
  };

  render() {
    const {
      input: { value },
      placeholder,
      options,
      meta: { error, submitFailed },
    } = this.props;
    const selectProps = {
      value,
      className: styles['select-dropdown'],
      placeholder,
      onChange: this.onChangeSelect,
      options,
      clearable: false,
      onSelectResetsInput: false,
      backspaceRemoves: false,
      isValidNewOption: () => false,
      onClose: () => {
        this.setState({ selectInstance: 1 - this.state.selectInstance });
      },
    };
    if (this.state.selectInstance === 1) {
      return (
        <div>
          <small className={styles.error}>
            {error && submitFailed ? error : ''}
          </small>
          <div className="form-group row">
            <div className="col-md-4">
              <span>Select Outlet:</span>
            </div>
            <div className="col-md-8">
              <Select {...selectProps} />
            </div>
          </div>
        </div>
      );
    }
    return (
      <div>
        <small className={styles.error}>
          {error && submitFailed ? error : ''}
        </small>
        <div className="form-group row">
          <div className="col-md-4">
            <span>Select Outlet:</span>
          </div>
          <div className="col-md-8">
            <span>
              <Select {...selectProps} />
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default CustomOutletDropdown;
